module.exports = __webpack_public_path__ + "img/text_rpbf.dc6f240b.png";